var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 90,
    viewBox: "0 0 56 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48973 29.8486L1 37.1189L3.09379 49.7402L0.999931 56.2544L4.72234 55.033L6.99068 59.1626L4.48969 83.7654L6.1764 88.4184L27.7547 89L25.1956 84.9868L25.4864 80.9736L28.1037 78.4726L27.7547 72.2492L29.6159 66.9564L29.4415 58.1738L34.5016 49.2168L39.5617 36.77L38.922 28.3946L45.6107 26.3589L50.7871 21.8222L53.3463 17.2273L50.6708 11.1784L52.6483 9.72435V7.10703L54.5095 5.07134L53.23 1H8.56107L6.06008 16.4712L7.16517 19.0885L4.7805 19.4375L6.35089 23.7997L4.83866 26.1843L4.48973 29.8486Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVt);
export default __webpack_public_path__ + "static/media/VT.7fa337f3d509edea310a6d325b0accd7.svg";
export { ForwardRef as ReactComponent };